import {
  SET_STATISTICS_DASHBOARD, StatisticsActionsType
} from './actions';

import {
  IStatisticsActionHandler,
  IStatisticsInitialState,
  IStatistics
} from './interfaces';

const StatisticsInitialState: IStatisticsInitialState = {
  stats: null
};

const setStatistics = ({
  state,
  payload
}: IStatisticsActionHandler): IStatisticsInitialState => {
  return {
    ...state,
    stats: payload as IStatistics
  };
};
const statisticsReducerHandlers = new Map([
  [SET_STATISTICS_DASHBOARD, setStatistics]
]);

const statisticsReducer = (
  state = StatisticsInitialState,
  action: StatisticsActionsType
): IStatisticsInitialState => {
  const handler = statisticsReducerHandlers.get(action.type);

  return (
    handler && {
      ...handler(<IStatisticsActionHandler>{
        state,
        payload: action.payload
      })
    }
  ) || {...state};
};

export default statisticsReducer;
